import React from "react";
import GoalServices from "../../../../services/goal.services";
import { ErrorTextComp, CheckBoxComp } from '../../../inputs/fields.component'
import { isNumberWithComma, showTitleTooltip } from "../../../../utils/function";
import { getCalculationProgressOption, getIntervalOptions, getIntervalText, getMeasureDataOptions, getMetricTypeOptions, getWeekDaysOptions } from "../../../../utils/metric";
import HelpTextComp from "../../../helper/helptext.component";
import { ButtonsComp, TypeFaceText } from "../../../inputs/buttons.component";
import SearchBoxComp from "../../../inputs/searchbox.component";
import PermissionComp from "./permission.component";
import { RollUpKrSearchTableComp, RollUpTableComp } from "./rolluptable.component";
import { reactLoader, removeReactLoader, constructNestedKRPayload } from "../../../../utils/common.js";
import DeleteCommonModal from '../../../../components/deleteCommonModal.component';
import KrAlignDependance from '../../../../components/okr/wizard/key_results/krAlignDependence';
import NestedInlineComp from "./NestedInline.component";
import AddKrTag from "../../../../krTags/components/addkrTag.component"
import { Checkbox, Textfield, Dropdown, Button } from '@workboard/wobo-ui';
import { getTargetValue } from '../../../common/getTargetValue.component'
import styled from 'styled-components';
import Customokr from "../../../custom_fields/customobj/Customokr";
import KrRelationshipWrapper from "./krRelationshipWrapper";
import KrMilestonesSection from './KrMilestonesSection';
import { krdetailConstants } from '../../../../constants/krdetails.constants';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import { isKrDurationChangedFromSaved } from '../../../../utils/krQuarterDuration';

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -12px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledCheckboxExclude = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
		padding: 0;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  max-width: fit-content;
  height: 39px !important;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  #result-value-dropdown{
    min-width: 220px;
  }
  #multiplier-show-dropdown{
    min-width: 118px;
  }
  #calculate-progress-dropdown, #calculate-progress-dropdown1{
    min-width: 240px;
  }
  #cal-overall-dropdown{
    min-width: 244px;
  }
  #select-day-dropdown{
    min-width: 120px;
  }
  #select-interval-dropdown{
    min-width: 112px;
  }
`;

const ROLLUP_KR_TYPE = "rollup_kr";
const ROLLUP_OKR_TYPE = "rollup_okr";
const SINGLE_ROLL_TYPE = "single_rollup_kr";

const ROLLUP_DS_METRICS = ["1", "2", "8", "9", 1, 2, 8, 9];
class RollupKRComp extends React.Component {
  constructor(props) {
    super(props);
    let metricObj = this.props.item || {};
    let isStretchEnabled = this.props.addOkrData.isStretchEnabled ?? this.props.goalDetails.isStretchEnabled ?? false;
    let committedKRFlag = isStretchEnabled && this.props.item && parseInt(this.props.item.committed_target) ? parseInt(this.props.item.committed_target) : 0;
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    let krObj = {
      target: "",
      stretch: "",
      initial_data: 0,
      measure_metric_data: 1,
      progress_type: 1,
      multiply_data: "",
      metric: 1,
      progress_consider: 1,
      interval: 2,
      weekly_update_day: 5,
      counting: 1
    },
      goalObj = { target: !isStretchEnabled ? 100 : '', progress_consider: 1, initial_data: 0, stretch: isStretchEnabled ? 100 : '' };
    let metricGoal = [],
      metricMetric = [],
      activeRollUp = "",
      multiply = false,
      doneKR = false,
      showAdvancedOption = false,
      isSameUnit = false,
      isMixedMetrics = false;
    if (Object.keys(metricObj).length) {
      let { source, type } = this.props.item;
      if ((source == 3 || source == 7) && (type == 1 || this.props.mitChildKr)) {
        if (!metricObj.initial_data) {
          metricObj.initial_data = 0;
        }
        krObj = metricObj.source == "3" ? metricObj : krObj;
        goalObj = metricObj.source == "3" ? goalObj : metricObj;
        metricGoal = metricObj.metricGoal || [];
        metricMetric = metricObj.metricMetric || [];
        activeRollUp = metricObj.source == "3" ? "rollup-kr" : "rollup-okr";
        if (metricObj.multiply_data) {
          multiply = true;
        }
        doneKR = true;
        let measureMetricData = metricObj.measure_metric_data;
        isSameUnit = this.isSameMeasureUnit(metricMetric);
        isMixedMetrics = this.isMixedMetricUnits(metricMetric);
        if (metricMetric.length == 1) {
          measureMetricData = (measureMetricData == 1 || measureMetricData == 4) ? measureMetricData : 1;
        }
        else {
          measureMetricData = isMixedMetrics ? 3 : (measureMetricData == 4 ? 1 : measureMetricData);
        }
        metricObj.measure_metric_data = measureMetricData;
        krObj.measure_metric_data = measureMetricData;
        showAdvancedOption = !!(metricMetric.length > 1 && metricObj.measure_metric_data != 5
          && metricObj.measure_metric_data != 6
          && metricObj.measure_metric_data != 3);
        if (isStretchEnabled) {
          krObj.stretch = metricObj.stretch_target !== null ? metricObj.stretch_target : (krObj.target && !committedKRFlag) ? krObj.target : '';
          goalObj.stretch = goalObj.stretch_target !== null ? goalObj.stretch_target : (goalObj.target && !committedKRFlag) ? goalObj.target : '';
          krObj.target = (krObj.stretch_target !== null) ||
            (committedKRFlag && krObj.stretch_target == null)
            ? krObj.target : ''
          goalObj.target = (goalObj.stretch_target !== null) ||
            (committedKRFlag && goalObj.stretch_target == null)
            ? goalObj.target : '';
        }
      }
    }
    this.state = {
      activeRollUp,
      multiply,
      metricGoal,
      metricMetric,
      addKR: true,
      doneKR,
      showAdvancedOption,
      isSameUnit,
      isMixedMetrics,
      errors: {},
      krObj,
      goalObj,
      hide: false,
      teamPermissionSelected:
        this.props.item && this.props.item.permission_teams
          ? this.props.item.permission_teams
          : this.props.goalDetails.type == 1 &&
            this.props.goalDetails.default_permission_teams &&
            Object.keys(this.props.goalDetails.default_permission_teams).length > 0
            ? this.props.goalDetails.default_permission_teams : [],
      bizPermissionSelected: this.props.item && this.props.item.permission_biz ? this.props.item.permission_biz : [],
      permissionstate:
        this.props.item && this.props.item.permission
          ? this.props.item.permission.split(",").map(Number)
          : this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
            Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8]) : [10],
      permissionHelpPopUp: false,
      dsMetric: this.props.mitChildKr && this.props.item && this.props.item.counting != null
        ? parseInt(this.props.item.counting)
        : this.props.mitChildKr && this.props.counting != null
        ? parseInt(this.props.counting)
        : this.props.item &&
        this.props.item.counting &&
        ROLLUP_DS_METRICS.includes(this.props.item.counting)
        ? parseInt(this.props.item.counting)
        : 1,
      metricDD: false,
      confirmPopup: false,
      krAlingSelected: this.props.item &&
        this.props.item.kr_aligns !== undefined &&
        this.props.item.kr_aligns.length > 0
        ? this.props.item.kr_aligns
        : [],
      krDependenciesSelected: this.props.item &&
        this.props.item.kr_dependent !== undefined &&
        this.props.item.kr_dependent.length > 0
        ? this.props.item.kr_dependent
        : [],
      committedKRFlag: this.props.item && this.props.item.committed_target != null ? this.props.item.committed_target : 0,
      tags: [],
      nplTags: this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags: this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName: this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList: this.props.tagsList ? this.props.tagsList : [],
      customFiledRequired: false,
      isCustomSave: [],
      isRequirdCustomOkr: [],
      customInputData: [],
      isStretchEnabled: isStretchEnabled,
      isAnuualQChange: false,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
      milestones: this.props.item?.milestones ?? [],
    };

    this.GoalServices = new GoalServices();
    this.krMilestonesSectionRef = React.createRef();

    this.clickButtonEvent = this.clickButtonEvent.bind(this);
    this.changeMultipiler = this.changeMultipiler.bind(this);
    this.changeExcludeObjective = this.changeExcludeObjective.bind(this);
    this.renderSearchKR = this.renderSearchKR.bind(this);
    this.clickKrItem = this.clickKrItem.bind(this);
    this.removeKr = this.removeKr.bind(this);
    this.addAnotherKR = this.addAnotherKR.bind(this);
    this.doneKR = this.doneKR.bind(this);
    this.checkKRValue = this.checkKRValue.bind(this);
    this.showAdvancedOption = this.showAdvancedOption.bind(this);
    this.hideAdvancedOption = this.hideAdvancedOption.bind(this);
    this.renderSearchObjective = this.renderSearchObjective.bind(this);
    this.clickObjectiveItem = this.clickObjectiveItem.bind(this);
    this.removeObjective = this.removeObjective.bind(this);
    this.saveRollUp = this.saveRollUp.bind(this);
    this.changeMetricTypeOption = this.changeMetricTypeOption.bind(this);
    this.changeTargetValue = this.changeTargetValue.bind(this);
    this.changeStretchValue = this.changeStretchValue.bind(this);
    this.changeMultiplierValue = this.changeMultiplierValue.bind(this);
    this.changeCalculationProgress = this.changeCalculationProgress.bind(this);
    this.changeMeasureDataTypeOption = this.changeMeasureDataTypeOption.bind(
      this
    );
    this.saveMetricData = this.saveMetricData.bind(this);
    this.changeInterval = this.changeInterval.bind(this);
    this.changeWeekDayUpdate = this.changeWeekDayUpdate.bind(this);
    this.krBeforeFilterValues = this.krBeforeFilterValues.bind(this);
    this.objectiveBeforeFilterValues = this.objectiveBeforeFilterValues.bind(this);
    this.reCalculateMeasureUnit = this.reCalculateMeasureUnit.bind(this);

    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.targetClick = this.targetClick.bind(this);
    this.clickEvent = this.clickEvent.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.saveAlignArr = this.saveAlignArr.bind(this);
    this.saveDependentArr = this.saveDependentArr.bind(this);
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.isSaveCustom = this.isSaveCustom.bind(this)
    this.renderError = this.renderError.bind(this);

    this.saveKrCompleted = this.saveKrCompleted.bind(this);
    this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
    this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
  }

  componentDidMount() {
    this.props.setSavedAnnualDuration(this.props.item.isQuarter, this.props.item.quarter_name, this.props.item.id)
    document.addEventListener("mousedown", this.clickEvent, false);
    console.log("hdahfhafhahfa", "RollupKRComp");
  }
  clickEvent(e) {
    if (
      !$(".metricTargetValue").is(e.target) &&
      $(".metricTargetValue").has(e.target).length === 0
    ) {
      if (this.state.metricDD) {
        this.setState({
          metricDD: false
        });
      }
    }
  }

  isSameMeasureUnit(rows = []) {
    let issame = false;
    if (rows.length) {
      let totalRows = rows.length;
      let firstRow = rows[0];
      let sameUnit = rows.filter(r => (firstRow.counting == r.counting &&
        firstRow.graph_type == r.graph_type && firstRow.metric == r.metric
        && firstRow.interval == r.interval
      ));
      issame = (sameUnit.length == totalRows);
    }
    return issame;
  }

  isMixedMetricUnits(metrics = []) {
    let isMixed = false;
    let metricsLength = metrics.length;
    if (metricsLength) {
      let percentage = metrics.filter(metric => metric.metric == 3);
      let percentageCount = percentage.length;
      if (percentageCount) {
        isMixed = (metricsLength != percentageCount);
      }
    }
    return isMixed;
  }

  permissionData(perData) {
    this.setState({ permissionstate: perData });
  }

  teamPermissionData(teamPerData) {
    this.setState({ teamPermissionSelected: teamPerData });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({ bizPermissionSelected: bizPerData });
  }

  changeTargetValue(e) {
    var v = e.target.value.trim();
    let { errors, krObj, goalObj } = this.state;
    let val = '';
    if (typeof errors['target'] !== 'undefined') {
      delete errors['target'];
    }
    if (this.state.activeRollUp == "rollup-kr") {
      val = ((v && isNumberWithComma(v)) || v == '') ? v : krObj['target'];
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { target: val }),
        errors,
      });
    } else {
      val = ((v && isNumberWithComma(v)) || v == '') ? v : goalObj['target'];
      this.setState({
        goalObj: Object.assign({}, this.state.goalObj, { target: val }),
        errors,
      });
    }
  }

  changeStretchValue(e) {
    let v = e.target.value.trim();
    let { errors, krObj, goalObj } = this.state;
    let val = '';
    if (typeof errors['stretch'] !== 'undefined') {
      delete errors['stretch'];
    }
    if (this.state.activeRollUp == "rollup-kr") {
      val = ((v && isNumberWithComma(v)) || v == '') ? v : krObj['stretch'];
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { stretch: val }),
        errors,
      });
    } else {
      val = ((v && isNumberWithComma(v)) || v == '') ? v : goalObj['stretch'];
      this.setState({
        goalObj: Object.assign({}, this.state.goalObj, { stretch: val }),
        errors,
      });
    }
  }

  changeStartValue = (e) => {
    var v = e.target.value.trim();
    let { errors, krObj, goalObj } = this.state;
    let val = '';
    if (typeof errors['start'] !== 'undefined') {
      delete errors['start'];
    }
    if (this.state.activeRollUp == "rollup-kr") {
      val = ((v && isNumberWithComma(v)) || v == '') ? v : krObj['initial_data'];
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { initial_data: val }),
        errors,
      });
    } else {
      val = ((v && isNumberWithComma(v)) || v == '') ? v : goalObj['initial_data'];
      this.setState({
        goalObj: Object.assign({}, this.state.goalObj, { initial_data: val }),
        errors,
      });
    }
  }

  changeMultiplierValue(e) {
    var v = e.target.value.trim();
    let { errors, krObj } = this.state;
    if (typeof errors['multiplier'] !== 'undefined') {
      delete errors['multiplier'];
    }
    // let val = ((v && isNumberWithComma(v)) || v == '') ? v : krObj['multiply_data'];
    this.setState({
      krObj: Object.assign({}, this.state.krObj, { multiply_data: v }),
      errors,
    });
  }

  changeMetricTypeOption(e, item) {
    if (item) {
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { metric: item }),
      });
    }
  }

  changeCalculationProgress(e, item) {
    if (item) {
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { progress_type: item }),
      });
    }
  }

  changeMeasureDataTypeOption(e, item) {
    if (item) {
      const startTargetValue = this.calculatingTarget(item, this.state.metricMetric);
      this.setState({
        krObj: Object.assign({}, this.state.krObj, {
          measure_metric_data: item,
          target: !this.state.isStretchEnabled ? startTargetValue["target"] : "",
          initial_data: startTargetValue["initial_data"],
          stretch: this.state.isStretchEnabled ? startTargetValue["stretch"] : ""
        }),
      });
    }
  }

  changeInterval(e, item) {
    if (item) {
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { interval: item }),
      });
    }
  }

  changeWeekDayUpdate(e, item) {
    if (item) {
      this.setState({
        krObj: Object.assign({}, this.state.krObj, {
          weekly_update_day: item,
        }),
      });
    }
  }

  showAdvancedOption(e) {
    this.setState({ showAdvancedOption: true });
  }

  hideAdvancedOption(e) {
    this.setState({ showAdvancedOption: false });
  }

  clickButtonEvent(item) {
    let oldActiveRollUp = this.state.activeRollUp;
    if (oldActiveRollUp != item.id) {
      this.setState({ activeRollUp: item.id, errors: {} });
    }
  }

  changeMultipiler(e) {
    this.setState({ multiply: e.target.checked, errors: {} });
  }

  changeExcludeObjective(e) {
    var chk = e.target.checked ? 0 : 1;
    if (this.state.activeRollUp == "rollup-kr") {
      this.setState({
        krObj: Object.assign({}, this.state.krObj, { progress_consider: chk }),
      });
    } else {
      this.setState({
        goalObj: Object.assign({}, this.state.goalObj, { progress_consider: chk }),
      });
    }
  }

  clickKrItem(e, item, searchBoxInst) {
    $(e.target).trigger("mouseleave");
    let metricMetric = this.state.metricMetric;
    let findKR = metricMetric.find(k => k.id == item.id);
    if (!findKR) {
      metricMetric = [...metricMetric, item];
      let stretch = '';
      let target = '';
      if (this.state.isStretchEnabled) {
        stretch = item["target"]
      } else {
        target = item["target"];
      }
      let { krObj, isSameUnit, showAdvancedOption, isMixedMetrics } = this.reCalculateMeasureUnit(metricMetric);
      this.setState({
        metricMetric,
        isSameUnit,
        isMixedMetrics,
        krObj: Object.assign({}, krObj, { target, stretch }),
        showAdvancedOption,
        errors: {},
      }, () => {
        if (searchBoxInst) {
          searchBoxInst.closeBox();
        }
      });
    }
  }

  clickObjectiveItem(e, item) {
    let { value, inst } = item;
    let chk = e.target.checked;
    let metricGoal = this.state.metricGoal;
    if (chk) {
      let findKR = metricGoal.find(k => k.id == value.id);
      if (!findKR) {
        metricGoal = [...metricGoal, value];
      }
    }
    else {
      metricGoal = metricGoal.filter(g => g.id != value.id)
    }
    this.setState({ metricGoal, errors: {} }, () => {
    });
  }

  sumOfTwoNumber = (n1, n2) => {
    if (n2) {
      if (typeof n2 === "string") return (n1 + Number(n2.replace("%", "")));
      else return (n1 + n2);
    } else {
      return (n1 + 0);
    }
  }

  roundOfValue = (num) => {
    if (typeof num === 'number' && !Number.isFinite(num)) {
      return 0;
    }
    if (num % 1 === 0) {
      return num;
    } else {
      // source ::: https://stackoverflow.com/questions/4187146/truncate-number-to-two-decimal-places-without-rounding
      var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (2 || -1) + '})?');
      return Number(num.toString().match(re)[0]);
    }
  }
  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }
  getInitialAndTargetValue = (metricMetric, dsMetric) => {
    let sum = 0, sumStart = 0, stretchSum = 0, stretchFlag = false, isTarget = false;
    metricMetric.map((item) => {
      if ((item.source == 2 && (item.metric == 3 || item.metric == 4)) || item.isMirrorWS) {
        if (this.state.isStretchEnabled) {
          if (!parseInt(item['committed_target'])) { // Normal KR flow
            stretchSum = this.sumOfTwoNumber(stretchSum, 100);
            stretchFlag = true;
          } else { // Committed KR & CT &ST KR flow
            if (parseFloat(item["stretch_target"])) {
              stretchSum = this.sumOfTwoNumber(stretchSum, item["stretch_target"]);
              stretchFlag = true;
            }
            if (parseFloat(item["target"])) {
              sum = this.sumOfTwoNumber(sum, 100);
              isTarget = true;
            }
          }
          if (!isTarget) { // Reset if there is no incomming target to avoid 0 prepopulated on edit modal
            sum = '';
          }
        } else {
          sum = this.sumOfTwoNumber(sum, 100);
        }
        sumStart = this.sumOfTwoNumber(sumStart, item["initial_data"]);
      } else if (dsMetric != item.counting && (item.counting == 2 || item.counting == 1)) {
        sum = this.sumOfTwoNumber(sum, item["initial_data"]);
        sumStart = this.sumOfTwoNumber(sumStart, item["target"]);
        if (this.state.isStretchEnabled && item["stretch_target"] != "") {
          stretchSum = this.sumOfTwoNumber(stretchSum, item["stretch_target"]);
          stretchFlag = true;
        }
      } else {
        sumStart = this.sumOfTwoNumber(sumStart, item["initial_data"]);
        if (this.state.isStretchEnabled) {
          if (!parseInt(item['committed_target'])) { // Normal KR flow
            stretchSum = this.sumOfTwoNumber(stretchSum, item["target"]);
            stretchFlag = true;
          } else { // Committed KR & CT &ST KR flow
            if (parseFloat(item["stretch_target"])) {
              stretchSum = this.sumOfTwoNumber(stretchSum, item["stretch_target"]);
              stretchFlag = true;
            }
            if (parseFloat(item["target"])) {
              sum = this.sumOfTwoNumber(sum, item["target"]);
              isTarget = true;
            }
          }
          if (!isTarget) { // Reset if there is no incomming target to avoid 0 prepopulated on edit modal
            sum = '';
          }
        } else { //Stretch Disabled flow
          sum = this.sumOfTwoNumber(sum, item["target"]);
        }
      }
    });
    let initialAndTarget = { sum, sumStart }
    if (stretchFlag) {
      initialAndTarget = { ...initialAndTarget, stretch: stretchSum };
    }
    return initialAndTarget;
  }

  calculatingTarget = (measure_metric_data, metricMetric, dsMetric = this.state.dsMetric) => {
    let target = "", initial_data = "", stretch = "";
    console.log('measure_metric_data')
    if (measure_metric_data == 5 || metricMetric.length === 1) {
      let initialTargetValue = this.getInitialAndTargetValue(metricMetric, dsMetric);
      target = this.roundOfValue(initialTargetValue.sum);
      initial_data = this.roundOfValue(initialTargetValue.sumStart);
      stretch = initialTargetValue.stretch ? this.roundOfValue(initialTargetValue.stretch) : "";
    } else if (measure_metric_data == 6) {
      let initialTargetValue = this.getInitialAndTargetValue(metricMetric, dsMetric);
      target = this.roundOfValue(initialTargetValue.sum / metricMetric.length);
      initial_data = this.roundOfValue(initialTargetValue.sumStart / metricMetric.length);
      stretch = initialTargetValue.stretch ? this.roundOfValue(initialTargetValue.stretch / metricMetric.length) : "";
    } else if (measure_metric_data == 3) {
      let initialTargetValue = this.getInitialAndTargetValue(metricMetric, dsMetric);
      if (dsMetric == 2) {
        initial_data = 100;
        target = (initialTargetValue.sumStart != 0) ? this.roundOfValue((initialTargetValue.sum * 100) / initialTargetValue.sumStart) : 0;
      } else {
        initial_data = (initialTargetValue.sum != 0) ? this.roundOfValue((initialTargetValue.sumStart * 100) / initialTargetValue.sum) : 0;
        target = !this.state.isStretchEnabled ? 100 : '';
        stretch = this.state.isStretchEnabled ? 100 : '';
      }
    }
    return { target, initial_data, stretch };
  }
  checkKRValue(e, item) {
    let metricMetric = this.state.metricMetric;
    if (e.target.checked) {
      let findKR = metricMetric.find(k => k.id == item.id);
      if (!findKR) {
        metricMetric = [...metricMetric, item];
      }
    } else {
      metricMetric = metricMetric.filter(k => k.id != item.id);
    }
    let { krObj, isSameUnit, showAdvancedOption, isMixedMetrics } = this.reCalculateMeasureUnit(metricMetric);
    let progressType = (metricMetric.length === 1 ? (item.progress_type) : this.state.krObj.progress_type);
    let dsMetric = !this.props.mitChildKr ? (metricMetric.length === 1 ? (item.counting == 2 ? item.counting : 1) : this.state.dsMetric) : this.state.dsMetric;
    const startTargetValue = this.calculatingTarget(krObj.measure_metric_data, metricMetric, dsMetric);
    let stretch = '';
    let target = '';
    if (this.state.isStretchEnabled) {
      if (startTargetValue["stretch"]) {
        target = startTargetValue["target"]
        stretch = startTargetValue["stretch"]
      } else {
        stretch = startTargetValue["target"];
      }
    } else {
      target = startTargetValue["target"]
    }
    let assignObject = { target, stretch, initial_data: startTargetValue["initial_data"], progress_type: progressType };
    this.setState({
      metricMetric,
      isSameUnit,
      isMixedMetrics,
      showAdvancedOption,
      dsMetric: dsMetric,
      krObj: Object.assign({}, krObj, assignObject),
      errors: {},
    });
  }

  krBeforeFilterValues(values = []) {
    let metricMetric = this.state.metricMetric;
    if (Array.isArray(values) && values.length && metricMetric.length) {
      let editMetricId = '';
      if (Object.keys(this.state.krObj).length) {
        editMetricId = this.state.krObj.id;
      }
      values = values.map((v) => {
        if (typeof v.metrics === 'undefined') {
          v.metrics = [];
        }
        else {
          v.metrics = v.metrics.filter(m => ((editMetricId == '' || editMetricId != m.id)));
        }
        return v;
      });
      values = values.filter(f => f.metrics.length);
    }
    return values;
  }

  objectiveBeforeFilterValues(values = []) {
    let metricGoal = this.state.metricGoal;
    if (Array.isArray(values) && values.length && metricGoal.length) {
      let currentGoalId = '';
      let goalDetails = this.props.goalDetails;
      if (typeof goalDetails.id !== 'undefined') {
        currentGoalId = goalDetails.id;
      }
      values = values.filter(g => (currentGoalId == '' || currentGoalId != g.id));
    }
    return values;
  }

  renderSearchKR(values = [], inst = null, type = null) {
    let metricMetric = this.state.metricMetric;
    if (values.length) {
      let attr = {};
      let showCheckBox = metricMetric.length > 0;
      if (!showCheckBox && type !== SINGLE_ROLL_TYPE) {
        attr.rowClick = this.clickKrItem;
      } else {
        attr.checkedValues = metricMetric.map(m => m.id);
        attr.checkBoxProps = {
          onChange: this.checkKRValue,
        };
      }
      if (values.length > 0) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $(".krBreak")[0].offsetTop });
      }
      return values.map(m => <RollUpKrSearchTableComp key={"search_key_" + m.id} value={m} attr={attr} inst={inst} />);
    } else {
      return null;
    }
  }

  renderSearchObjective(value, inst) {
    let subtext = value.teamName ? `Team: ${value.teamName}` : '';
    // let valToProgress = value.progress >= 0 ?  value.progress+'%' : '--'
    //let year = "FY" + moment(value.achieveDate,"MMM DD, YYYY").format("YY");
    let year = value.okrPeriod ?? "FY" + moment(value.achieveDate, "MMM DD, YYYY").format("YY"); // for fix ww-18856
    if (year.includes('Q')) {
      let yearArray = year.split(' ');
      year = yearArray[0] + ' FY ' + yearArray[1].slice(-2)
    } else if (year.includes('FY')) {
      year = ' FY ' + year.slice(-2)
    }
    subtext = `${value.ownerFullName} @@DOTCLASS@@ ${year}`;
    subtext = value.teamName ? `${value.teamName} @@DOTCLASS@@ ${subtext}` : subtext;

    let checkboxId = `search_rollup_okr_${value.id}`;
    let checkboxProps = {
      checked: (!!this.state.metricGoal.find(g => g.id == value.id)),
    };

    return (
      <div className="render-search-kr-item" data-testid="render-search-kr-item">
        <div className="rollup-table rollup-table-goal">
          <div className="rollup-row">
            <div className="rollup-col rollup-checkbox">
              <CheckBoxComp
                key={checkboxId}
                id={checkboxId}
                subclassDefined="displayInLineBlk"
                labelStyle={{
                  marginTop: "-5px"
                }}
                item={{
                  value,
                  inst
                }}
                onChange={this.clickObjectiveItem}
                checkboxProps={checkboxProps}
              />
            </div>
            <div className="rollup-col rollup-col-gname highlightRow">
              <div
                className="goaltitle showtooltip-title"
                {...showTitleTooltip(value.goal)}
                style={{ fontWeight: "normal" }}
              >
                {value.goal}
              </div>
              {subtext ? (
                <div className="subtitle showtooltip-title" {...showTitleTooltip(subtext.replace(/@@DOTCLASS@@/ig, '.'))}
                  dangerouslySetInnerHTML={{ __html: subtext.replace(/@@DOTCLASS@@/ig, '<span class="dotClass">.</span>') }}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  removeKr(e, item) {
    let metricMetric = this.state.metricMetric.filter(k => k.id != item.id);
    let updateObj = { ...this.state };
    updateObj.metricMetric = metricMetric;
    let startTargetValue = { target: "", stretch: "", initial_data: "" };
    let progressType = (metricMetric.length === 1 ? (metricMetric[0].progress_type) : this.state.krObj.progress_type);
    let dsMetric = (metricMetric.length === 1 ? (metricMetric[0].counting == 2 ? metricMetric[0].counting : 1) : this.state.dsMetric);
    if (!metricMetric.length) {
      updateObj.addKR = true;
      updateObj.doneKR = false;
    }
    else {
      updateObj = { ...updateObj, ...this.reCalculateMeasureUnit(metricMetric) };
      startTargetValue = this.calculatingTarget(updateObj.krObj.measure_metric_data, metricMetric, dsMetric);
    }
    let stretch = '';
    let target = '';
    if (this.state.isStretchEnabled) {
      if (startTargetValue["stretch"]) {
        target = startTargetValue["target"]
        stretch = startTargetValue["stretch"]
      } else {
        stretch = startTargetValue["target"];
      }
    } else {
      target = startTargetValue["target"]
    }
    let assignObject = { target, stretch, initial_data: startTargetValue["initial_data"], progress_type: progressType };
    updateObj.krObj = Object.assign({}, updateObj.krObj, assignObject);
    updateObj.dsMetric = dsMetric;
    this.setState(updateObj);
  }

  reCalculateMeasureUnit(metricMetric = []) {
    let isSameUnit = this.isSameMeasureUnit(metricMetric);
    let isMixedMetrics = this.isMixedMetricUnits(metricMetric);
    let krObj = this.state.krObj;
    let showAdvancedOption = this.state.showAdvancedOption;
    let measureMetricData = krObj.measure_metric_data;
    if (metricMetric.length == 1) {
      showAdvancedOption = false;
      measureMetricData = (measureMetricData == 1 || measureMetricData == 4) ?
        measureMetricData : 1;
    }
    else {
      if (!isSameUnit) {
        showAdvancedOption = false;
      }
      measureMetricData = isMixedMetrics ? 3 : ((!showAdvancedOption && (measureMetricData == 5 || measureMetricData == 6 || measureMetricData == 3))
        ? measureMetricData : 5);
      measureMetricData = (measureMetricData == 4) ? 1 : measureMetricData;
    }
    krObj = { ...krObj, measure_metric_data: measureMetricData };
    return {
      isSameUnit,
      isMixedMetrics,
      krObj,
      showAdvancedOption,
    };
  }

  removeObjective(e, item) {
    let metricGoal = this.state.metricGoal.filter(k => k.id != item.id);
    this.setState({ metricGoal });
  }

  addAnotherKR(e) {
    this.setState({ addKR: true, doneKR: false });
  }

  doneKR(e) {
    this.setState({ doneKR: true, addKR: false, errors: {} });
  }

  renderError(field, errorClass = "") {
    return <ErrorTextComp errors={this.state.errors} field={field} errorClass={errorClass} />;
  }

  getMilestonesPayload() {
    // Ensure milestones is an array before attempting to use array methods
    if (!Array.isArray(this.state.milestones)) {
      return '';
    }
    // milestones need to be an object with keys as index and values as milestone object (for api request)
    const milestones = this.state.milestones
      .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
      .reduce((acc, milestone, index) => ({
        ...acc,
        [index]: {
          id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
          date: milestone.date,
          label: milestone.label,
          target: milestone.target,
        }
      }), {});

    return Object.keys(milestones).length > 0 ? milestones : '';
  }

  handleMilestonesChange(milestones) {
    this.setState({ milestones });
  }

  saveKrCompleted(callback = null, data = {}) {
    if (!this.props.mitChildKr) {
      window.dispatchEvent(new CustomEvent('krDataRefresh'));
    }
    if (callback && typeof callback === "function") {
      callback(data);
    } else {
      this.props.closeKrRightPane(true);
    }
  }

  saveMetricData(params = {}, callback = null) {

    let { actions, item, goalDetails } = this.props;
    let goalId = goalDetails.id;
    if (typeof goalId !== "undefined" && Object.keys(params).length) {
      let krId = '';
      let _this = this;
      if (typeof item !== "undefined" && typeof item["id"] !== "undefined") {
        params.id = item["id"];
        krId = params.id;
      }
      if (goalDetails && goalDetails.all_metrics == 1) {
        let teaMperArr = [], bizPerArr = [];
        if (Array.isArray(goalDetails.permission_teams) && goalDetails.permission_teams.length) {
          teaMperArr = goalDetails.permission_teams.map(val => val.id);
        }
        if (Array.isArray(goalDetails.permission_biz) && goalDetails.permission_biz.length) {
          bizPerArr = goalDetails.permission_biz.map(val => val.id);
        }
        params.permission_teams = teaMperArr;
        params.permission_biz = bizPerArr;
        params.permission = goalDetails.permission;
      } else {
        params.permission_teams = this.state.teamPermissionSelected.map(
          val => val.id
        );
        params.permission_biz = this.state.bizPermissionSelected.map(val => val.id);
        params.permission = this.state.permissionstate.join(',');
      }
      let krAlignSel = this.state.krAlingSelected;
      let dependentKrsSel = this.state.krDependenciesSelected;
      let krAligns = [];
      let dependentKrs = [];

      if (Object.keys(krAlignSel).length > 0) {
        krAlignSel.map(item => {
          krAligns.push(item.id);
        });
      }

      if (Object.keys(dependentKrsSel).length > 0) {
        dependentKrsSel.map(item => {
          dependentKrs.push(item.id);
        });
      }
      params.krAligns = krAligns;
      params.dependentKr = dependentKrs;
      let nlpIds = this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
      let tagids = this.state.tags.length ? this.state.tags : ['']
      let finalTagsIds = [...nlpIds, ...tagids]
      params.krTagIds = finalTagsIds;
      params["nested_krs"] = constructNestedKRPayload(this.props);
      params.real_owner = this.props.realOwner.id;
      let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
      params.coOwners = coOwners.length > 0 ? Array.prototype.map
        .call(coOwners, s => s.id)
        .toString() : '';
      if (this.props.isChildKr && this.props.fromParentKr) {
        //params.ownerName = this.state.data_provider.name;
        params.duration = this.props.childKrDuration;
        params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        if (this.state.activeRollUp == "rollup-kr") {
          params.metricMetric = this.state.metricMetric;
        }
        if (this.state.activeRollUp == "rollup-okr") {
          params.metricGoal = this.state.metricGoal;
        }

        if (this.props.item.parent) {
          params.parent = this.props.item.parent;
        }
        params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
        this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
      } else if (this.props.mitChildKr) {
        params.counting = this.props.item?.counting ?? this.props.counting ?? this.state.dsMetric;
        params.duration = this.props.childKrDuration;
        params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        if (this.state.activeRollUp == "rollup-kr") {
          params.metricMetric = this.state.metricMetric;
        }
        if (this.state.activeRollUp == "rollup-okr") {
          params.metricGoal = this.state.metricGoal;
        }
        this.props.saveQuarterlyKR(params, this.props.mitIndex);
        this.saveKrCompleted(callback, params);
        // this.props.closeKrRightPane();
      } else {
        if (this.props.item.parent) {
          params.start_date = this.props.childKrDuration.start;
          params.end_date = this.props.childKrDuration.end;
          params.parent = this.props.item.parent;
        }
        reactLoader(true);
        this.GoalServices.addEditKr({ goalId, metric: params }).then(
          (response) => {
            removeReactLoader();
            if (response.data) {
              this.setState({
                confirmPopup: false,
                isAnuualQChange: false,
              });
              if (!this.props.onlyMetEdit) {
                let result = response.data.data;
                let krWeightage = null;
                if (result && result.krWeightage) {
                  krWeightage = result.krWeightage;
                  delete result['krWeightage'];
                }
                result = {
                  clusterItems: this.props.clusterData,
                  clusterCount: this.props.clusterData.length,
                  ...result
                };
                if (result.parent) {
                  actions.addUpdateNestedKr(result)
                } else {
                  if (krId) {
                    actions.editNewKr(krId, result);
                  } else {
                    actions.addNewKr(result);
                  }
                }


                if (krWeightage) {
                  _this.props.MetricChangeWeight(krWeightage);
                }
                // this.GoalServices.triggerGoalMetricDetails({ goalId, metricId: result.id });
              }
              this.saveKrCompleted(callback, response.data.data);
              // _this.props.closeKrRightPane(true);
            }
          }
        );
      }
    }
  }

  saveRollUp(isError = false, callback = null) {
    const { t } = this.props;
    let errors = {};
    this.isSaveCustom(this.state.customInputData)
    this.setState({isCustomSave:[]})

    // Check for milestones validation errors
    if (this.krMilestonesSectionRef.current && !this.krMilestonesSectionRef.current.validateMilestones()) {
      toastr.error(t('Milestone dates and values must be within start and target range'));
      return false;
    }

    let {
      activeRollUp = '',
      multiply = false,
      metricMetric = [],
      metricGoal = [],
      addKR,
      doneKR,
      krObj,
      goalObj,
      dsMetric,
    } = this.state;
    //let metricName = $("#metric-name-text").val();
    let metricName = this.props.krText;
    if (
      typeof metricName === "undefined" ||
      metricName == null ||
      metricName == ""
    ) {
      errors["metricName"] = true;
    }
    if (activeRollUp == "") {
      errors["select_type"] = t("Select what you want to measure");
    }
    if (activeRollUp == "rollup-kr") {
      let isNew = typeof this.props.item["id"] === "undefined";
      if (!metricMetric.length) {
        errors["krs"] = t('Search and select a key result');
        if (!errors["metricName"]) {
          let elem = document.getElementById("search-input-box");
          elem.setAttribute("aria-invalid", "true");
          setTimeout(() => {
            document.getElementById("search-input-box").focus();
          });
        }

      }
      // if (!doneKR) {
      //   errors["another_kr"] = "Add another "+t('key result')+" or select Done adding";
      // }
      if (this.state.isStretchEnabled) {
        if (krObj.target === "" && krObj.stretch === "") {
          errors["target"] = errors["stretch"] = t("Enter value");
        }
        if (krObj.stretch && !isNumberWithComma(krObj.stretch)) {
          errors["stretch"] = t("Enter numeric value");
        }
      } else {
        if (krObj.target === "") {
          errors["target"] = t("Enter value");
        }
      }
      if (krObj.target && !isNumberWithComma(krObj.target)) {
        errors["target"] = t("Enter numeric value");
      }
      if ((krObj.target && isNumberWithComma(krObj.target)) && (krObj.stretch && isNumberWithComma(krObj.stretch))) {
        if ((dsMetric == 1 || dsMetric == 9) && parseFloat(krObj.stretch) < parseFloat(krObj.target)) {
          errors["stretch"] = t("Stretch target should be greater than committed");
        }
        if ((dsMetric == 2 || dsMetric == 8) && parseFloat(krObj.stretch) > parseFloat(krObj.target)) {
          errors["stretch"] = t("Stretch target should be less than committed");
        }
      }

      if (krObj.initial_data === "") {
        errors["start"] = t("Enter value");
      } else if (!isNumberWithComma(krObj.initial_data)) {
        errors["start"] = t("Enter numeric value");
      }
      if (dsMetric == 1 &&
        ((!this.state.isStretchEnabled &&
          Number(krObj.initial_data) > krObj.target) ||
          (this.state.isStretchEnabled &&
            ((krObj.target != "" && Number(krObj.initial_data) > krObj.target) || (krObj.stretch != "" && Number(krObj.initial_data) > krObj.stretch))))
      ) {
        errors["start"] = t("Starting value should be less than target");
        if (this.state.isStretchEnabled && Number(krObj.initial_data) > krObj.target) {
          errors["target"] = t('highlightOnly');
        }
        if (this.state.isStretchEnabled && Number(krObj.initial_data) > krObj.stretch) {
          errors["stretch"] = t('highlightOnly');
        }
      } else if (dsMetric == 2 &&
        ((!this.state.isStretchEnabled &&
          krObj.target > Number(krObj.initial_data)) ||
          (this.state.isStretchEnabled &&
            (krObj.target > Number(krObj.initial_data) || krObj.stretch > Number(krObj.initial_data))))
      ) {
        errors["start"] = t("Starting value should be greater than target");
        if (this.state.isStretchEnabled && Number(krObj.target) > krObj.initial_data) {
          errors["target"] = t('highlightOnly');
        }
        if (this.state.isStretchEnabled && Number(krObj.stretch) > krObj.initial_data) {
          errors["stretch"] = t('highlightOnly');
        }
      }
      if (this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length > 0) {
        errors["customokr"] = t(`Please enter required field`);
        this.setState({ isCustomSave: this.state.isRequirdCustomOkr })

      }

      if (multiply && !krObj.multiply_data) {
        errors["multiplier"] = t("Set a multiplier");
      } else if (multiply && !isNumberWithComma(krObj.multiply_data)) {
        errors["multiplier"] = t("Enter numeric value");
      }
    } else if (activeRollUp == "rollup-okr") {
      if (!metricGoal.length) {
        errors["okrs"] = t('Search and select an objective');
        if (!errors["metricName"]) {
          let elem = document.getElementById("search-input-box");
          elem.setAttribute("aria-invalid", "true");
          setTimeout(() => {
            document.getElementById("search-input-box").focus();
          });
        }
      }
      if (this.state.isStretchEnabled) {
        if (goalObj.target === "" && goalObj.stretch === "") {
          errors["target"] = t("Enter target");
          errors["stretch"] = t("Enter stretch");
        }
      } else {
        if (goalObj.target === "") {
          errors["target"] = t("Enter target");
        }
      }
      if (goalObj.target && !isNumberWithComma(goalObj.target)) {
        errors["target"] = t("Enter numeric value");
      }
      if (goalObj.stretch && !isNumberWithComma(goalObj.stretch)) {
        errors["stretch"] = t("Enter numeric value");
      }
      if ((goalObj.target !== "" && isNumberWithComma(goalObj.target)) && (goalObj.stretch !== "" && isNumberWithComma(goalObj.stretch))) {
        if (parseFloat(goalObj.stretch) < parseFloat(goalObj.target)) {
          errors["stretch"] = t("Stretch target should be greater than committed");
        }
      }
      if (goalObj.initial_data === "") {
        errors["start"] = t("Enter value");
      } else if (!isNumberWithComma(goalObj.initial_data)) {
        errors["start"] = t("Enter numeric value");
      } else if ((goalObj.target && goalObj.initial_data > goalObj.target) || (goalObj.stretch && goalObj.initial_data > goalObj.stretch)) {
        errors["start"] = t("Starting value should be less than target");
      }
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      } else if (errors.select_type && errors.select_type.length > 0) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 50 });
      } else if (errors.another_kr && errors.another_kr.length > 0) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $(".krRightPaneContent")[0].scrollHeight - 400 });
      } else if (errors.target && errors.target.length > 0) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $(".krRightPaneContent")[0].scrollHeight - 450 });
      }
      if (errors.customokr && errors.customokr.length > 0) {
        setTimeout(() => {
          this.setState({ customFiledRequired: true })
          document.querySelector('#cutomobj').scrollIntoView({
            behavior: 'smooth',
          })
        }, 200)
      }
    } else {
      if (this.props.krType != this.props.lastType && this.props.addEditFlag) {
        this.setState({
          confirmPopup: true
        })
      }
      else if (isKrDurationChangedFromSaved(this.props.item, this.props.kr_duration, this.props.goalDetails)) {
        this.setState({
          confirmPopup: true,
          isAnuualQChange: true,
        })
      } else {
        let params = {};
        let editMetric = this.props.item || {};
        let goalDetails = this.props.goalDetails;
        let permission = goalDetails.permission || '';
        if (activeRollUp == "rollup-kr") {
          let {
            target,
            initial_data,
            measure_metric_data,
            progress_type,
            multiply_data,
            metric,
            progress_consider,
            interval,
            weekly_update_day,
            stretch
          } = krObj;
          if (this.state.metricMetric && this.state.metricMetric.length == 1) {
            interval = this.state.metricMetric[0].interval;
          }
          let isSameUnit = this.state.isSameUnit;
          params.name = this.props.krText;
          params.kr_duration = this.props.kr_duration;
          params.isQuarter = this.props.isQuarter;
          params.description = this.props.krNote;
          params.counting = this.state.dsMetric ? this.state.dsMetric : 1;
          params.target = target;
          params.initial_data = initial_data;
          params.real_owner = this.props.realOwner.id;
          let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
          params.coOwners = coOwners.length > 0 ? Array.prototype.map
            .call(coOwners, s => s.id)
            .toString() : '';
          params.interval = interval;
          params.weekly_update_day = weekly_update_day;
          params.src_metrics = this.state.metricMetric.map(m => m.id);
          let measureMetricData = measure_metric_data;
          params.measure_metric_data = measureMetricData;
          params.customField = JSON.stringify(this.props.customFieldsData);
          if (measureMetricData == 3 || measureMetricData == 4 || measureMetricData == 5 || measureMetricData == 6) {
            progress_type = 1;
          }
          params.progress_type = progress_type;
          params.multiply_data = multiply ? multiply_data : '';
          let firstMetric = this.state.metricMetric[0];
          params.metric = multiply ? metric :
            (typeof firstMetric.metric != 'undefined' && parseInt(firstMetric.metric) > 0 ? firstMetric.metric : 3);
          params.source = 3;
          params.progress_consider = (this.props.mitChildKr) ? progress_consider : progress_consider ? 1 : 0;
          if (!this.state.isStretchEnabled) {
            params.committed_target = this.state.committedKRFlag == 1 ? 1 : 0;
          }
          params.stretchTarget = stretch;
          // Include milestones data if available
          params.milestones = this.getMilestonesPayload();
          if (!isError) {
            this.saveMetricData(params, callback);
          }
        } else if (activeRollUp == "rollup-okr") {
          let { target, progress_consider, initial_data, stretch } = goalObj;
          params.name = this.props.krText;
          params.kr_duration = this.props.kr_duration;
          params.isQuarter = this.props.isQuarter;
          params.description = this.props.krNote;
          params.target = target;
          params.initial_data = initial_data;
          params.interval = 2;
          params.weekly_update_day = 5;
          params.goalSourceId = this.state.metricGoal.map(g => g.id);
          params.goal_roll_up_check = 1;
          params.source = 7;
          params.progress_consider = progress_consider;
          params.customField = JSON.stringify(this.props.customFieldsData);
          params.stretchTarget = stretch;
          if (!isError) {
            this.saveMetricData(params, callback);
          }
        }
      }
    }
  }

  exitDeleteModal() {

    this.setState({ confirmPopup: false });
  }
  saveItems() {
    let params = {};
    let editMetric = this.props.item || {};
    let goalDetails = this.props.goalDetails;
    let permission = goalDetails.permission || '';
    let isError = false;
    let kr_duration = this.props.kr_duration;
    let {
      activeRollUp = '',
      multiply = false,
      krObj,
      goalObj,
    } = this.state;
    if (activeRollUp == "rollup-kr") {
      let {
        target,
        measure_metric_data,
        progress_type,
        multiply_data,
        metric,
        progress_consider,
        interval,
        weekly_update_day,
        stretch
      } = krObj;
      let isSameUnit = this.state.isSameUnit;
      params.name = this.props.krText;
      params.kr_duration = kr_duration;
      params.isQuarter = this.props.isQuarter;
      params.isPeriodChange = this.state.isAnuualQChange
      params.description = this.props.krNote;
      params.counting = this.state.dsMetric ? this.state.dsMetric : 1;
      params.target = target;
      params.real_owner = this.props.realOwner.id;
      let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
      params.coOwners = coOwners.length > 0 ? Array.prototype.map
        .call(coOwners, s => s.id)
        .toString() : '';
      params.interval = interval;
      params.weekly_update_day = weekly_update_day;
      params.src_metrics = this.state.metricMetric.map(m => m.id);
      let measureMetricData = measure_metric_data;
      params.measure_metric_data = measureMetricData;
      params.customField = JSON.stringify(this.props.customFieldsData);
      if (measureMetricData == 3 || measureMetricData == 4 || measureMetricData == 5 || measureMetricData == 6) {
        progress_type = 1;
      }
      params.progress_type = progress_type;
      params.multiply_data = multiply ? multiply_data : '';
      let firstMetric = this.state.metricMetric[0];
      params.metric = multiply ? metric :
        (typeof firstMetric.metric != 'undefined' && parseInt(firstMetric.metric) > 0 ? firstMetric.metric : 3);
      params.source = 3;
      params.progress_consider = progress_consider ? 1 : '';
      params.stretchTarget = stretch;
      if (!isError) {
        this.saveMetricData(params);
      }
    } else if (activeRollUp == "rollup-okr") {
      let { target, progress_consider, stretch } = goalObj;
      params.name = this.props.krText;
      params.description = this.props.krNote;
      params.target = target;
      params.interval = 2;
      params.weekly_update_day = 5;
      params.goalSourceId = this.state.metricGoal.map(g => g.id);
      params.goal_roll_up_check = 1;
      params.source = 7;
      params.progress_consider = progress_consider;
      params.customField = JSON.stringify(this.props.customFieldsData);
      params.stretchTarget = stretch;
      if (!isError) {
        this.saveMetricData(params);
      }
    }
  }

  getErrorClass(field) {
    return (typeof this.state.errors[field] !== 'undefined') ? ' errorBorder  ' : '';
  }

  reverseTargetAndInitialValue = (dsMetric) => {
    let target = !this.state.isStretchEnabled ? this.state.krObj.target :
      (this.state.krObj.target ? this.state.krObj.target : this.state.krObj.stretch);
    let initial_data = this.state.krObj.initial_data;
    if (dsMetric != this.state.dsMetric) return { target: initial_data, initial_data: target };
    else return { target: target, initial_data: initial_data };
  }

  targetClick(e, id) {
    const { metricMetric, krObj } = this.state;
    const startTargetValue = this.reverseTargetAndInitialValue(id);
    let stretch = '';
    let target = '';
    if (this.state.isStretchEnabled) {
      if (this.state.krObj.target) {
        target = startTargetValue["target"];
      } else {
        stretch = startTargetValue["target"]
      }
    } else {
      target = startTargetValue["target"];
    }
    let setStateParam = {
      dsMetric: id,
      errors: {},
      krObj: Object.assign({}, krObj,
        {
          target,
          stretch: (stretch != '' && target == '') ? stretch : this.state.krObj.stretch,
          initial_data: startTargetValue["initial_data"]
        }
      ),
    };
    this.setState(setStateParam);
  }

  getProgressOptions() {
    const progressOptions = getCalculationProgressOption('new');
    const options = [...progressOptions];
    if (this.state.isMixedMetrics) {
      return options.filter(option => option.value == '3');
    }
    return options;
  }

  saveAlignArr(alignData) {
    this.setState({
      krAlingSelected: alignData
    })
  }
  saveDependentArr(dependentData) {
    this.setState({
      krDependenciesSelected: dependentData
    })
  }
  handleCommittedKRChange = () => {
    this.setState({
      committedKRFlag: this.state.committedKRFlag == 1 ? 0 : 1
    });
  }
  isSaveCustom(isVal) {
    let arr = [];
    let j = 0;
    let keyArrCategory = []
    let valArray = []
    isVal && Object.keys(isVal).forEach((v) => {
      j++;
      isVal[v]["customFields"] &&
        Object.keys(isVal[v]["customFields"]).forEach(objv => {
          keyArrCategory.push(objv)
          if (isVal[v]["customFields"][objv]['is_required'] == '1'
            && (isVal[v]["customFields"][objv]["text"] == undefined || isVal[v]["customFields"][objv]["text"] == [])
          ) {
            arr.push(objv, v)
          }
          if (isVal[v]["customFields"][objv]["text"]) {
            valArray.push(isVal[v]["customFields"][objv]["text"])
          } else {
            valArray.push('')
          }
        })
      if (j == Object.keys(isVal).length) {
        this.setState({ isRequirdCustomOkr: [...arr] })
      }
      let finalDataArray = []
      for (let i = 0; i < valArray.length; i++) {
        if (Array.isArray(valArray[i])) {
          valArray[i].forEach(val => {
            finalDataArray.push({ id: keyArrCategory[i], val: val.name, object_type: '6' })
          })
        }
        else {
          finalDataArray.push({ id: keyArrCategory[i], val: valArray[i], object_type: '6' })
        }

      }
    })

  }

  isRequiredCustomOkrFiled(isVal, id) {
    let cust_id = this.state.isCustomSave.find((u) => u == id);
    let ar = this.state.isCustomSave ? this.state.isCustomSave : '';
    let fr = ar.filter(
      (u) => u != cust_id
    )
    this.setState({ isCustomSave: fr })
    this.isSaveCustom(isVal)
    this.setState({ customInputData: isVal })
  }
  saveTag = (childData) => {
    this.setState({ tags: childData })
  }
  updateTags(Newtags) {
    this.setState({
      selectednlplTagsName: Newtags
    })
  }
  setDefultValue() {
    {
      if ((this.props.kr_duration.qname ?? '') !== (this.props.item.quarter_name ?? '')) {
        Promise.all(this.state.metricMetric.map((i) => {
          this.removeKr("e", i)
        })).then(() => this.props.dropDownValueChanged(false))
      }
    }
  }

  render() {
    this.props.dropDownValueChangedValue && this.props.kr_duration && this.setDefultValue()
    // measure_metric_data
    const { t, addOkrData = {} } = this.props;
    let { activeRollUp = '', isMixedMetrics = false, krObj, goalObj } = this.state;
    let buttons = [
      {
        id: "rollup-kr",
        label: t('Roll-up key results'),
        iconClass: "icon icon-kr-24px-bluegreen",
        buttonWrapperClass: activeRollUp == "rollup-kr" ? "active" : "",
        buttonClick: this.clickButtonEvent
      },
      {
        id: "rollup-okr",
        label: t('Roll-up objectives'),
        iconClass: "icon icon-outline-bar_chart-24px-bluegreen",
        buttonWrapperClass: activeRollUp == "rollup-okr" ? "active" : "",
        buttonClick: this.clickButtonEvent
      }
    ];
    let rows = this.state.metricMetric;
    let objectiveRows = this.state.metricGoal;
    let { start_date = 'new', target_date = 'new' } = this.props.goalDetails;
    let isNew = typeof this.props.item["id"] === 'undefined';
    let krId = "";
    if (typeof this.props.item !== "undefined" && typeof this.props.item["id"] !== "undefined") {
      krId = this.props.item["id"];
    }

    let searchStartDate = '';
    let searchEndDate = '';
    if (this.props.isChildKr && this.props.childKrDuration.start) {
      searchStartDate = moment(this.props.childKrDuration.start, "MM/DD/YYYY").format("MMM DD, YYYY");
      searchEndDate = moment(this.props.childKrDuration.end, "MM/DD/YYYY").format("MMM DD, YYYY");
    } else {
      searchStartDate = ((this.props.isAnnualMit || this.props.isMitEdit) && this.props.dateSegment) ? this.props.dateSegment.startDate : (this.props.isQuarter ? this.props.kr_duration.start : start_date);
      searchEndDate = ((this.props.isAnnualMit || this.props.isMitEdit) && this.props.dateSegment) ? this.props.dateSegment.endDate : (this.props.isQuarter ? this.props.kr_duration.end : target_date);
    }
    let krUrl = `goal/searchKrs?type=kr&goal_start=${searchStartDate}&goal_end=${searchEndDate}&krId=${krId}&source_from=rollup`;
    let progressType = null;
    let measureMetricData = null;
    let newMeasureMetricData = 5;
    if (activeRollUp == 'rollup-kr') {
      progressType = this.state.krObj.progress_type
        ? this.state.krObj.progress_type
        : 1;
      measureMetricData = this.state.krObj.measure_metric_data
        ? this.state.krObj.measure_metric_data
        : 1;
      if (rows.length == 1) {
        measureMetricData = (measureMetricData == 1 || measureMetricData == 4) ? measureMetricData : 1;
      }
      else {
        measureMetricData = isMixedMetrics ? 3
          : measureMetricData;
      }
      newMeasureMetricData = isMixedMetrics ? 3 : (!(measureMetricData == 5 || measureMetricData == 6 || measureMetricData == 3) ? 5 : measureMetricData);
    }
    let isError = Object.keys(this.state.errors).length;
    const textFieldClass = isError ? this.getErrorClass('start') : '';
    const textFieldClassTarget = isError ? this.getErrorClass('target') : '';
    const textFieldClassStretch = isError ? this.getErrorClass('stretch') : '';

    const showCustomFieldHeader = (
      this.props.customData
      && Object.keys(this.props.customData).length > 0
      && !this.props.mitChildKr
    )

    const showCustomFields = (
      (
        this.props.addOkrData.groupKRCustomFields
        || this.props.groupKRCustomFields
      )
      && !this.props.mitChildKr
    );

    const renderCustomFields = () => {
      return (
        <>
          {showCustomFieldHeader && <div className="krBreak" style={{ marginBottom: "-10px" }} aria-hidden="true" />}
          {
            showCustomFields
            && (
              <Customokr
                customData={this.props.customData}
                isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                customFiledRequired={true}
                renderError={this.renderError}
                isCustomSave={this.state.isCustomSave}
              />
            )
          }
        </>
      )
    }

    // TODO: continue breaking this up.  The problem is all the local vars are only
    //  available in this function.
    const renderKrRollup = () => {
      return (
        <div className="rollup-kr-comp-kr">
          <div className="fieldcontent" style={{ display: 'flex' }}>
            <label>
              <div className="wherekrDataCome">
                {t('Find and add key results to roll up')}
                <TypeFaceText />
              </div>
              <SearchBoxComp
                key="kr-box1"
                minLength="2"
                wrapperClass="rollup-kr-box "
                expandSearchBox={true}
                url={krUrl}
                inputProps={{
                  placeholder: t('Search by key result owner, or team name'),
                  className: this.getErrorClass("krs")
                }}
                parentKRID={this.props.parentKRID}
                id={this.props.item.id}
                renderResultComp={this.renderSearchKR}
                beforeFilterValues={this.krBeforeFilterValues}
                type={ROLLUP_KR_TYPE}
                listType={SINGLE_ROLL_TYPE}
              />
            </label>
          </div>
          {this.renderError("krs")}
          {rows.length ? (
            <div className="fieldcontent">
              <div className="wherekrDataCome">{t('Selected key result')}(s):</div>
              <div className="krDataOverflow">
                {rows.map(r => (
                  <RollUpTableComp
                    key={"rollup_metric_" + r.id}
                    type="kr"
                    tableClass="rollup-kr-table"
                    row={r}
                    removeItem={this.removeKr}
                    selectListFlag={true}
                  />
                ))}
              </div>
            </div>
          ) : (
            ""
          )}
          {rows.length ? (
            <div>
              <div className="fieldcontent">
                <div className="basickrstarttargets basic-flex-box" style={{ alignItems: 'start' }}>
                  <div className={(!this.state.isStretchEnabled || !isError) ? "basic-flex-content marginR5" : "basic-flex-content marginR5 error-width-basic-kr"}>
                    <div className="wherekrDataCome" id="rollup-startValue">
                      {t('Start value')}
                      <TypeFaceText />
                    </div>
                    <div className="input-text-wrapper">
                      <Textfield
                        aria-labelledby="rollup-startValue"
                        data-testid="wbui-textarea"
                        type="text"
                        value={this.state.krObj.initial_data}
                        className={`text-target-field text-target-width ${textFieldClass}` + (this.state.isStretchEnabled ? ' stretch-text-target-width' : ' text-target-width')}
                        onChange={e => this.changeStartValue(e)}
                        autoComplete="off"
                      />
                    </div>
                    {isError ? this.renderError("start") : ""}
                  </div>
                  <div className="basic-flex-content marginR5">
                    <div className="wherekrDataCome" id="result-value-label">{t('Result value ')}
                      <HelpTextComp key="resultvaluehelp">
                        <div>
                          <ul>
                            <li>
                              <b>{t('Should increase to')} </b>
                              {`${t('example')}: ${t('Starting from 0 MQLs moving to 10 MQLs')}`}
                            </li>
                            <li>
                              <b>{t('Should decrease to')}</b>
                              {`${t('example')}: ${t('Starting from 100 bugs moving to 10 bugs')}`}
                            </li>
                          </ul>
                        </div>
                      </HelpTextComp>
                    </div>
                    <StyledDropdown
                      options={getTargetValue(true)}
                      onChange={(e) => { this.targetClick(e, e.target["value"]) }}
                      id={"result-value-dropdown"}
                      data-testid={"result-value-dropdown"}
                      value={Number(
                        this.props.mitChildKr && this.props.item?.counting != null
                          ? this.props.item.counting
                          : this.props.mitChildKr && this.props.counting != null
                          ? this.props.counting
                          : this.state.dsMetric
                      )}
                      aria-labelledby='result-value-label'
                      showStartNodeOnSelect
                      optionTitleProp="name"
                      optionValueProp="value"
                      disabled={!!this.props.mitChildKr}
                      MenuProps={{
                        style: {
                          zIndex: '1500000'
                        }
                      }}
                    />
                  </div>
                  <div className={"basic-flex-content " + (!this.state.isStretchEnabled ? "marginR12" : "marginT18")} style={{ marginRight: "7px" }}>
                    <div className={!this.state.isStretchEnabled ? "wherekrDataCome" : "wherekrDataCometext"} id="rollup-target">
                      {t('Target value')}
                      <TypeFaceText />
                    </div>
                    {this.state.isStretchEnabled && (
                      <div className="inLineBlk left">
                        <div className="wherekrDataCome">
                          {t('Committed target')}
                          <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                            {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                          </HelpTextComp>
                        </div>
                      </div>
                    )}
                    <div className="input-text-wrapper">
                      <Textfield
                        aria-labelledby="rollup-target"
                        data-testid="wbui-textarea"
                        type="text"
                        value={this.state.krObj.target}
                        className={`text-target-field text-target-width ${textFieldClassTarget}` + (this.state.isStretchEnabled ? ' stretch-text-target-width' : ' text-target-width')}
                        placeholder="Enter Value"
                        onChange={e => this.changeTargetValue(e)}
                        autoComplete="off"
                      />
                    </div>
                    {isError ? this.renderError("target") : ""}
                  </div>

                  {this.state.isStretchEnabled &&
                    (<div className="target-input-box marginT18">
                      <div className="wherekrDataCome" id="rollup-stretch">
                      </div>
                      {<div className="inLineBlk left">
                        <div className="wherekrDataCome">
                          {t('Stretch target')}
                          <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                            {('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
                          </HelpTextComp>
                        </div>
                      </div>
                      }
                      <div className="input-text-wrapper">
                        <Textfield
                          aria-labelledby="rollup-stretch"
                          data-testid="wbui-textarea"
                          type="text"
                          value={this.state.krObj.stretch}
                          className={`text-target-field stretch-text-target-width ${textFieldClassStretch}`}
                          placeholder="Enter Value"
                          onChange={e => this.changeStretchValue(e)}
                          autoComplete="off"
                        />
                      </div>
                      {isError ? this.renderError("stretch") : ""}
                    </div>
                    )}
                  <div className="clear" />
                </div>
              </div>
              {rows.length > 1 && !this.state.showAdvancedOption ? (
                <div className="fieldcontent">
                  <div className="left marginR12">
                    <div className="wherekrDataCome" id="calculate-progress1">
                      {t('Calculate progress for this result as')}
                    </div>
                    <div>
                      <StyledDropdown
                        data-testid="myAlign"
                        id="calculate-progress-dropdown1"
                        aria-labelledby="calculate-progress1"
                        value={Number(newMeasureMetricData)}
                        autoMenuWidth
                        onChange={(event) => {
                          this.changeMeasureDataTypeOption(event, event.target["value"]);
                        }}
                        optionTitleProp="name"
                        optionValueProp="value"
                        options={this.getProgressOptions()}
                        MenuProps={{
                          style: {
                            zIndex: '1500000'
                          },
                        }}
                      />
                      <div className="clear" />
                    </div>
                  </div>
                  {!this.props.mitChildKr &&
                    <div className="left">
                      <div className="wherekrDataCome">
                        {t('Calculate and graph progress')}
                      </div>
                      <div className="input-text-wrapper">
                        <div className="left">
                          <StyledDropdown
                            data-testid="myAlign"
                            id="select-interval-dropdown"
                            aria-labelledby="select-interval"
                            value={Number(this.state.krObj.interval)}
                            autoMenuWidth
                            onChange={(event) => {
                              this.changeInterval(event, event.target["value"]);
                            }}
                            optionTitleProp="name"
                            optionValueProp="value"
                            options={getIntervalOptions('default', addOkrData.isEnabledBiweeklyKR, false, this.state.krObj.interval === krdetailConstants.INTERVAL_BIQUARTERLY)}
                            MenuProps={{
                              style: {
                                zIndex: '1500000'
                              },
                            }}
                          />
                          <div className="clear" />
                        </div>
                        {(this.state.krObj.interval == "2" || this.state.krObj.interval == "6") ? (
                          <div className="left">
                            <div className="left ontext">{t('on')}</div>
                            <div className="left">
                              <StyledDropdown
                                data-testid="myAlign"
                                id="select-day-dropdown"
                                aria-label={t("select day to update")}
                                value={Number(this.state.krObj.weekly_update_day)}
                                autoMenuWidth
                                onChange={(event) => {
                                  this.changeWeekDayUpdate(event, event.target["value"]);
                                }}
                                optionTitleProp="name"
                                optionValueProp="value"
                                options={getWeekDaysOptions()}
                                MenuProps={{
                                  style: {
                                    zIndex: '1500000'
                                  },
                                }}
                              />
                              <div className="clear" />
                            </div>
                            <div className="clear" />
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="clear" />
                      </div>
                    </div>
                  }
                  <div className="clear" />
                </div>
              ) : (
                ""
              )}
              {rows.length > 0 && !this.state.showAdvancedOption ? (
                <div className="fieldcontent">
                  {
                    this.state.isSameUnit ?
                      <Button
                        data-testid="bluelink-text"
                        className="bluelink-text"
                        onClick={e => this.showAdvancedOption(e)}
                        variant="ghost"
                      >
                        {t('Show advanced options')}
                      </Button>
                      :
                      ""
                  }
                </div>
              ) : (
                ""
              )}
              {rows.length > 0 && this.state.showAdvancedOption ? (
                <div className="">
                  <div className="advanced-option">
                    <div className="fieldcontent marginR12">
                      <div className="wherekrDataCome" id="calculate-progress">
                        {rows.length > 1 ? 'Calculate ' + getIntervalText(this.state.krObj.interval, true) + t(` progress for this result as`) + ': ' : t('For each update value use') + ': '}
                        <HelpTextComp>
                          <div>
                            <ul>
                              <li>
                                <b>{t('Achieved values') + ':'} </b>{t(`If selected key results have achieved values of "4" and "5", these numbers will either be totaled or averaged.`)}
                              </li>
                              <li>
                                <b>{t('Latest update') + ':'} </b> {t(`If selected key results have a last update of "3" and "5", these last numbers will either be totaled or averaged.`)}
                              </li>
                              {(this.state.dsMetric == 1) ? (<li>
                                <b>{t('Progress percentage') + ':'}</b>{t(`If selected key result have progresses of "30%" and "50%", these percentages will either be totaled or averaged.`)}
                              </li>) : ''}
                            </ul>
                          </div>
                        </HelpTextComp>
                      </div>
                      <div>
                        <StyledDropdown
                          data-testid="myAlign"
                          id="calculate-progress-dropdown"
                          aria-labelledby="calculate-progress"
                          value={Number(measureMetricData)}
                          autoMenuWidth
                          onChange={(event) => {
                            this.changeMeasureDataTypeOption(event, event.target["value"]);
                          }}
                          optionTitleProp="name"
                          optionValueProp="value"
                          options={rows.length > 1 ? this.getProgressOptions() : getMeasureDataOptions((this.state.dsMetric == 1) ? '' : 'lower')}
                          MenuProps={{
                            style: {
                              zIndex: '1500000'
                            },
                          }}
                        />
                        <div className="clear" />
                      </div>
                    </div>
                    {(measureMetricData == 1 || measureMetricData == 2) ? (
                      <div className="fieldcontent">
                        <div className="wherekrDataCome">
                          {t('Calculate overall progress for this result as')}{" "}
                          <HelpTextComp popUpClass="leftAlign" >
                            <div>
                              <ul>
                                <li>
                                  <b>{t('Last entered value')}:</b> {t(`If weekly progress is "4", overall progress is also "4".`)}
                                </li>
                                <li>
                                  <b>{t('Total of all entered values')}:</b> {t(`If the weekly progresses are "2","3", and "4", the overall progress is "9".`)}
                                </li>
                                <li>
                                  <b>{t('Average of all entered values')}:</b> {t(`If the weekly progresses are "2", "3", and "4", the overall progress is "3".`)}
                                </li>
                              </ul>
                            </div>
                          </HelpTextComp>
                        </div>
                        <StyledDropdown
                          data-testid="CalculateOverDropDown"
                          id="cal-overall-dropdown"
                          aria-labelledby="cal-overall"
                          value={Number(progressType)}
                          autoMenuWidth
                          onChange={(e) => {
                            this.changeCalculationProgress(e, e.target["value"]);
                          }}
                          optionTitleProp="name"
                          optionValueProp="value"
                          options={getCalculationProgressOption()}
                          MenuProps={{
                            style: {
                              zIndex: '1500000'
                            },
                          }}
                        />
                        <div className="clear" />
                      </div>
                    ) : ''}
                  </div>
                  <div className="fieldcontent displayMultiplier" style={{ display: 'flex' }}>
                    <CheckBoxComp
                      id="multiplier"
                      checkboxProps={{ checked: this.state.multiply }}
                      label={t("Multiply updates by a multiplier")}
                      onChange={this.changeMultipiler}
                    />{" "}<HelpTextComp compStyle={true}>
                      <b>{t('Example')}:</b> {`${t('If weekly updates are numbers for NA, you can use a')} 0.3 ${t('multiplier to compare EMEA and NA key results apples to apples since NA is a larger part of the business.')}`}
                    </HelpTextComp>
                  </div>
                  {this.state.multiply ? (
                    <div className="fieldcontent">
                      <div>
                        <div className="left" style={{ width: "105px" }}>
                          <div className="wherekrDataCome" id='rollup-mul'>
                            {t('Multiplier')}
                            <TypeFaceText />
                          </div>
                          <div className="input-text-wrapper">
                            <Textfield
                              aria-labelledby="rollup-mul"
                              data-testid="wbui-textarea"
                              type="text"
                              name="multiplier"
                              value={this.state.krObj.multiply_data}
                              isError={isError && this.getErrorClass('multiplier') !== ''}
                              className={`text-target-field text-target-width ${textFieldClassTarget}`}
                              onChange={e => this.changeMultiplierValue(e)}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="left" style={{ width: "150px" }}>
                          <div className="wherekrDataCome" id="multiplier-show-label">
                            {t('Show results as')}
                          </div>
                          <div className="input-text-wrapper">
                            <StyledDropdown
                              data-testid="rollup-show"
                              id="multiplier-show-dropdown"
                              aria-labelledby="multiplier-show-label"
                              value={Number(this.state.krObj.metric)}
                              autoMenuWidth
                              onChange={(event) => {
                                this.changeMetricTypeOption(event, event.target["value"])
                              }}
                              optionTitleProp="name"
                              optionValueProp="value"
                              options={getMetricTypeOptions()}
                              MenuProps={{
                                style: {
                                  zIndex: '1500000'
                                },
                              }}
                            />
                            <div className="clear" />
                          </div>
                        </div>
                        <div className="clear" />
                        {isError ? this.renderError("multiplier") : ''}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {rows.length > 0 && this.state.showAdvancedOption ? (
                    <div className="fieldcontent">
                      <Button
                        data-testid="bluelink-text"
                        className="bluelink-text"
                        onClick={e => this.hideAdvancedOption(e)}
                        variant="ghost"
                      >
                        {t('Hide advanced options')}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
              {renderCustomFields()}
              {
                rows.length > 0 ?
                  <div>
                    {
                      !this.props.isChildKr && !this.props.mitChildKr &&
                      <div className="breakline" />
                    }
                    {
                      (this.props.addOkrData.display_nested_kr &&
                        !this.props.isChildKr && !this.props.mitChildKr &&
                        Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
                      <NestedInlineComp
                        {...this.props}
                        actions={this.props.actions}
                        nested_krs={this.props.nested_krs}
                        updateNestedKrs={this.props.updateNestedKrs}
                      />
                    }

                    {
                      !this.props.isChildKr && !this.props.mitChildKr &&
                      <KrAlignDependance {...this.props}
                        saveDependentArr={this.saveDependentArr}
                        saveAlignArr={this.saveAlignArr}
                        krAlingArr={this.props.item.kr_aligns}
                        krDependenciesArr={this.props.item.kr_dependent} />
                    }
                    {!this.props.mitChildKr && !this.props.isChildKr && (
                      <KrMilestonesSection ref={this.krMilestonesSectionRef} {...this.props} metricState={this.state} metric={this.props.item} onChange={this.handleMilestonesChange} />
                    )}
                    <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
                    {!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveRollUp} />}
                    {!this.props.mitChildKr && <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
                      nplTags={this.state.nplTags} selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
                    />}
                    {
                      !this.props.isChildKr && !this.props.mitChildKr &&
                      <div className="fieldcontent">
                        <StyledCheckboxExclude
                          id="exclude_objective"
                          label={t("Exclude from objective progress calculation")}
                          isChecked={(this.state.krObj.progress_consider) == 0}
                          onChange={this.changeExcludeObjective}
                        />
                      </div>
                    }
                    {!this.props.mitChildKr &&
                      <div className="fieldcontent">
                        {!(
                          this.props.goalDetails &&
                          this.props.goalDetails.all_metrics == 1
                        ) && (
                            <div className="pT10">
                              <div className="viewPermissionArea">
                                <span>
                                  {t('View permissions in addition to')}{" "}
                                  {this.props.goalDetails.type == 1 ? " team " : " owner "}
                                  <div className="metricTargetHelptext permissionHelpText"
                                    onMouseEnter={(event) => {
                                      this.setState({ permissionHelpPopUp: true });
                                    }}
                                    onMouseLeave={(event) => {
                                      this.setState({ permissionHelpPopUp: false });
                                    }}
                                  />
                                  {this.state.permissionHelpPopUp && (
                                    <div className="basic-popup">
                                      {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                                    </div>
                                  )}
                                </span>
                              </div>
                              <div className="pB10">
                                <PermissionComp
                                  {...this.props}
                                  teamPermissionData={this.teamPermissionData}
                                  bizPermissionData={this.bizPermissionData}
                                  permissionData={this.permissionData}
                                  hide={this.state.hide}
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    }
                  </div>
                  : ''
              }
            </div>
          ) : (
            ""
          )}
        </div>
      );

    };

    // TODO: continue breaking this up.  The problem is all the local vars are only
    //  available in this function.
    const renderOkrRollup = () => {
      return (
        <div className="rollup-kr-comp-kr">
          <div className="fieldcontent">
            <div className="wherekrDataCome">
              {t('Search for objective by name, owner or team')}
              <TypeFaceText />
            </div>
            <div>
              <SearchBoxComp
                key="okr-box"
                minLength="2"
                wrapperClass="rollup-objective-box"
                expandSearchBox={true}
                url={"goal/searchKrs?type=okr&goal_start= " + searchStartDate + "&goal_end=" + searchEndDate + "&source_from=rollup"}
                inputProps={{
                  placeholder: t("Search for objective by name, owner or team"),
                  className: this.getErrorClass("okrs")
                }}
                renderSearchItem={this.renderSearchObjective}
                goalId={this.props.goalDetails.id}
                beforeFilterValues={this.objectiveBeforeFilterValues}
                moveDropDownSearch={true}
                type={ROLLUP_OKR_TYPE}
              />
            </div>
            {this.renderError("okrs")}
          </div>
          {objectiveRows.length ? (
            <div>
              <div className="fieldcontent">
                <div className="wherekrDataCome">{t('Selected objective')}(s):</div>
                <div className="krDataOverflow">
                  {objectiveRows.map(r => (
                    <RollUpTableComp
                      key={"rollup_objectivie_" + r.id}
                      type="okr"
                      tableClass="rollup-kr-table"
                      row={r}
                      removeItem={this.removeObjective}
                    />
                  ))}
                </div>
              </div>
              <div className="fieldcontent">
                <div className="basickrstarttargets basic-flex-box" style={{ alignItems: 'start' }}>
                  <div className="target-input-box marginR5">
                    <div className={!this.state.isStretchEnabled ? "wherekrDataCome" : "wherekrDataCometext"} id="rollupOkrProgress">
                      {t('Target progress')}(%)
                      <TypeFaceText />
                    </div>
                    {this.state.isStretchEnabled && (<div className="marginL0">
                      {t('Committed target')}
                      <HelpTextComp popUpClass="rightAlign" wrapperClass="committedKRHelpText marginL3">
                        {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                      </HelpTextComp>
                    </div>)}
                    <div className="input-text-wrapper">
                      <Textfield
                        type="text"
                        aria-labelledby="rollupOkrProgress"
                        data-testid="wbui-textarea"
                        name="target-progress"
                        className={"text-target-field" + (this.state.isStretchEnabled ? ' stretch-text-target-width' : ' text-target-width')}
                        placeholder="Enter Value"
                        value={this.state.goalObj.target}
                        onChange={e => this.changeTargetValue(e)}
                        autoComplete="off"
                      />
                    </div>
                    {isError ? this.renderError("target") : ''}
                  </div>
                  {this.state.isStretchEnabled && (<div className="target-input-box marginR5">
                    <div className="wherekrDataCome" id="rollup-stretch">
                    </div>
                    <div className="marginL0">
                      {t('Stretch target')}
                      <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                        {t('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
                      </HelpTextComp>
                    </div>
                    <div className="input-text-wrapper">
                      <Textfield
                        type="text"
                        aria-labelledby="rollupOkrProgress"
                        data-testid="wbui-textarea"
                        name="target-progress"
                        className="text-target-field stretch-text-target-width"
                        placeholder="Enter Value"
                        value={goalObj.stretch}
                        onChange={e => this.changeStretchValue(e)}
                        autoComplete="off"
                      />
                    </div>
                    {isError ? this.renderError("stretch") : ''}
                  </div>)}
                </div>
                {renderCustomFields()}
              </div>
              {
                (!this.props.isChildKr && !this.props.mitChildKr) &&
                <div className="breakline" />
              }
              {
                (this.props.addOkrData.display_nested_kr &&
                  !this.props.isChildKr && !this.props.mitChildKr &&
                  Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
                <NestedInlineComp
                  {...this.props}
                  actions={this.props.actions}
                  nested_krs={this.props.nested_krs}
                  updateNestedKrs={this.props.updateNestedKrs}
                />
              }
              {
                (!this.props.isChildKr && !this.props.mitChildKr) &&
                <KrAlignDependance {...this.props}
                  saveDependentArr={this.saveDependentArr}
                  saveAlignArr={this.saveAlignArr}
                  krAlingArr={this.props.item.kr_aligns}
                  krDependenciesArr={this.props.item.kr_dependent} />
              }
              <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
              {!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveRollUp} />}
              {!this.props.mitChildKr && <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
                nplTags={this.state.nplTags} selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
              />}
              {
                !this.props.isChildKr && !this.props.mitChildKr &&
                <div className="fieldcontent">
                  <StyledCheckboxExclude
                    id="exclude_objective"
                    label={t("Exclude from objective progress calculation")}
                    isChecked={(this.state.goalObj.progress_consider) == 0}
                    onChange={this.changeExcludeObjective}
                  />
                </div>
              }
              {!this.props.mitChildKr &&
                <div className="fieldcontent">
                  {!(
                    this.props.goalDetails &&
                    this.props.goalDetails.all_metrics == 1
                  ) && (
                      <div className="pT10">
                        <div className="viewPermissionArea">
                          <span>
                            {t('View permissions in addition to')}{" "}
                            {this.props.goalDetails.type == 1 ? " team " : " owner "}
                            <div className="metricTargetHelptext permissionHelpText"
                              onMouseEnter={(event) => {
                                this.setState({ permissionHelpPopUp: true });
                              }}
                              onMouseLeave={(event) => {
                                this.setState({ permissionHelpPopUp: false });
                              }}
                            />
                            {this.state.permissionHelpPopUp && (
                              <div className="basic-popup">
                                {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                              </div>
                            )}
                          </span>
                        </div>
                        <div className="pB10">
                          <PermissionComp
                            {...this.props}
                            teamPermissionData={this.teamPermissionData}
                            bizPermissionData={this.bizPermissionData}
                            permissionData={this.permissionData}
                            hide={this.state.hide}
                          />
                        </div>
                      </div>
                    )}
                </div>
              }
            </div>
          ) : (
            ""
          )}
        </div>
      );
    }


    return (
      <div className="rollup-kr-comp-wrapper">
        <div>
          <div className="wherekrDataCome">
            {t('Where do you want to measure with?')}
            <TypeFaceText />
          </div>
          <ButtonsComp buttons={buttons} addEditFlag={this.props.addEditFlag} />
          {this.renderError("select_type")}
        </div>
        {activeRollUp == "rollup-kr" && renderKrRollup()}
        {activeRollUp == "rollup-okr" && renderOkrRollup()}
        {
          this.state.confirmPopup &&
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t(this.state.isAnuualQChange ? 'Save Key Result with new duration' : 'Save Key Result with New Data Type')}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t(this.state.isAnuualQChange
              ? 'Are you sure you want to change the duration on this Key Result? This will eliminate all Updates and Confidence Flags on the Key Result.'
              : 'Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')}
            buttonText={t(this.state.isAnuualQChange ? 'Change duration' : 'Save')}
          />

        }
        <div style={{ height: "70px" }}></div>
      </div>
    );
  }
}

export default RollupKRComp
